import _ from 'lodash';

import { serviceNames, statuses } from '../../constants/project';
import { formatService } from '../../selectors/projects/services';
import { Project, ProjectService } from '../../types/entities';

export const getActiveProjectService = (
  service?: ProjectService,
): ProjectService | undefined => {
  if (!service) {
    return;
  }

  if (service.status !== statuses.READY) {
    return;
  }

  return formatService(service);
};

export const getProjectImageService = (
  project?: Project,
): ProjectService | undefined => {
  return project && _.find(project.services, { name: serviceNames.image });
};

export const getProjectFileService = (
  project?: Project,
): ProjectService | undefined => {
  return project && _.find(project.services, { name: serviceNames.file });
};
